<eventq-dialog-popover
  [open]="open()"
  [title]="title()"
  [cancelLabel]="cancelLabel()"
  [confirmLabel]="confirmLabel()"
  [confirmDisabled]="submitDisabled()"
  [anchor]="anchor()"
  [placement]="resolvedPlacement()"
  [panelWidth]="panelWidth()"
  (closed)="closed.emit()"
  (confirmed)="onConfirm()"
>
  <div class="arm-site-popover__body">
    <mat-icon class="arm-site-popover__icon" aria-hidden="true">verified_user</mat-icon>
    <p class="arm-site-popover__copy">
      <span class="arm-site-popover__question">{{ question() }}</span>
      <span class="arm-site-popover__site-name">{{ siteName() }}</span>
    </p>
  </div>
</eventq-dialog-popover>
